module.exports = __webpack_public_path__ + "img/product-preview-89.1cd19ea.png";